module.exports = __webpack_public_path__ + "img/password.04db24cf.svg";